import { Box, BoxProps, Heading } from "@chakra-ui/react";
import { Team } from "common";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { FaCrown } from "react-icons/fa";
import { TeamBanner } from "../utils/TeamBanner";

interface LeaderboardPanelItemProps {
  team: Team;
  paddingBottom: any;
  isFirst: boolean;
  position: number;
  background?: BoxProps["background"];
}

export const LeaderboardPanelItem = ({
  team,
  paddingBottom,
  isFirst,
  position,
  background,
}: LeaderboardPanelItemProps) => {
  return (
    <Box
      width={isFirst ? "40%" : "30%"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
    >
      {isFirst ? (
        <Box color={"yellow.500"} paddingBottom={6}>
          <FaCrown size={75} />
        </Box>
      ) : null}
      <Box
        padding={4}
        background={background ?? isFirst ? "gray.300" : "gray.200"}
        display={"flex"}
        width={"100%"}
        flexDir={"column"}
        alignItems={"center"}
        borderTopRadius={4}
      >
        <Box position={"relative"} bottom={8}>
          <TeamBanner
            padding={2}
            color={team.color}
            iconType={team.iconType}
            iconColor={team.iconColor}
            width={70}
          />
        </Box>
        <Heading fontSize={"x-large"}>{team.name}</Heading>
        <Heading
          fontSize={"xx-large"}
          color={THEME_COLOR_SCHEME}
          paddingBottom={8}
        >
          {team.points}
        </Heading>
        <Box
          paddingTop={paddingBottom}
          fontSize={`calc(6rem - ${position}rem)`}
          fontWeight={"bold"}
          fontStyle={"italic"}
          color={"purple.500"}
        >
          {position}
        </Box>
      </Box>
    </Box>
  );
};
